var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.pageLoading)?_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"wrapper-content"},[_c('div',{staticClass:"d-none d-lg-block login-bg"}),_c('div',{staticClass:"p-3 p-sm-5 login-content"},[_c('router-view')],1)])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }